(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/unsubscribe', {
      templateUrl: 'modules/outside/unsubscribe/unsubscribe.html',
      controller: 'UnsubscribeCtrl'
    });
  }]).controller('UnsubscribeCtrl', ['$scope', '$routeParams', '$http', 'Api', 'wsConfig', '$location', function ($scope, $routeParams, $http, Api, wsConfig, $location) {
    $scope.orgContext = null;
    $scope.yourAccountUrl = wsConfig.indexUrl + "#/my-account";
    var token = $location.search().token;
    $scope.email = $location.search().email;
    if (!$scope.email) {
      $scope.unsubscribeError = true;
      $scope.unsubscribeErrorMessage = "There was no email to unsubscribe";
      return;
    }
    $http.post(Api.url("/email-blacklist?token=" + token, true), {
      email: $scope.email
    }).then(function addEmailSuccess() {
      $scope.unsubscribed = true;
    }, function addEmailError(response) {
      if (response.status === 409) {
        $scope.unsubscribed = true;
      } else {
        $scope.unsubscribeError = true;
        $scope.unsubscribeErrorMessage = "There was an error trying to unsubscribe " + $scope.email;
      }
    });
    $scope.subscribe = function () {
      resetValues();
      $http['delete'](Api.url("/email-blacklist/" + $scope.email + "?token=" + token, true)).then(function deleteEmailSuccess() {
        $scope.resubscribed = true;
      }, function deleteEmailError(response) {
        if (response.status === 404) {
          $scope.resubscribed = true;
        } else {
          $scope.resubscribeError = true;
        }
      });
    };
    function resetValues() {
      $scope.unsubscribed = false;
      $scope.unsubscribeError = false;
      $scope.unsubscribeErrorMessage = undefined;
      $scope.resubscribed = false;
      $scope.resubscribeError = false;
    }
  }]);
})();
